<template>
  <div>
    <div class="d-flex align-items-center">
      <div class="w-100">
        <label>{{ label }}</label>
        <v-select
          placeholder="Busque por nombre"
          :options="listOptions"
          :name="name"
          :value="optionSelected"
          :class="{ 'v-select-danger': danger, 'select-size-sm': small }"
          :disabled="isDisabled"
          @input="onInput"
          :clearable="isClearable"
        >
          <template #spinner>
            <b-spinner
              small
              v-if="sanitaryCompaniesState.loading"
              :style="{ opacity: sanitaryCompaniesState.loading ? 1 : 0 }"
              variant="primary"
            />
          </template>
          <template slot="no-options">
            no hay tipos de documentos para el criterio de búsqueda
          </template>
        </v-select>
      </div>
      <vs-icon
        v-if="!isClearable"
        class="ml-2 mt-5 pt-1 cursor-pointer"
        icon="remove_circle_outline"
        size="small"
        v-tooltip="'Eliminar selección'"
        color="danger"
        @click="clearSanitary"
      />
    </div>
    <div v-if="danger">
      <small>
        <span class="text-danger"> {{ dangerText }} </span>
      </small>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

export default {
  name: 'ListSanitaryCompanies',
  computed: {
    ...mapGetters('List', ['sanitaryCompaniesState']),
    optionSelected() {
      return this.sanitaryCompaniesState.list.find((option) => option.label === this.value);
    },
    isDisabled() {
      return this.disabled
        || !this.sanitaryCompaniesState.list.length
        || this.sanitaryCompaniesState.loading;
    },
    listOptions() {
      if (this.withEmail) {
        return this.sanitaryCompaniesState.list
          .filter((sanitary) => sanitary.extra.correos.length && sanitary);
      }
      return this.sanitaryCompaniesState.list;
    }
  },
  methods: {
    ...mapActions('List', ['fetchSanitaryCompanies']),
    onInput(event) {
      this.$emit('input', event?.label);
    },
    getOption() {
      return this.sanitaryCompaniesState.list.find((option) => option.label === this.value);
    }
  },
  created() {
    this.fetchSanitaryCompanies(this.companyToLoad);
  },
  props: {
    name: { type: String, required: true },
    label: { type: String, default: 'Empresas sanitarias' },
    value: { type: String },
    danger: { type: Boolean },
    dangerText: { type: String },
    disabled: { type: Boolean, default: false },
    block: { type: Boolean, default: true },
    small: { type: Boolean, default: false },
    isClearable: { type: Boolean, default: true },
    clearSanitary: { type: Function, default: () => {} },
    companyToLoad: {
      type: String,
      required: false,
      default: null
    },
    withEmail: { type: Boolean, default: false }
  }
};

</script>
